// extracted by mini-css-extract-plugin
export default {"root":"MobileMenuBar_root__jQXZD","brand":"MobileMenuBar_brand__iOOzq"};